import { TreeProjectChoice, TREE_PROJECT_PROBABILITY_MIN, TREE_PROJECT_PROBABILITY_RANDOM_MAX } from '../tree-projects';

export const getRandomTreeProjectId = (treeProjects: TreeProjectChoice[]) => {
  if (treeProjects.length === 0) {
    throw new Error('No tree projects provided');
  }

  const randomNumber =
    Math.floor(Math.random() * (TREE_PROJECT_PROBABILITY_RANDOM_MAX - TREE_PROJECT_PROBABILITY_MIN + 1)) +
    TREE_PROJECT_PROBABILITY_MIN;

  const project = treeProjects.find(
    p => randomNumber >= p.probabilityLowerBound && randomNumber < p.probabilityUpperBound,
  );

  if (!project) {
    throw new Error(
      `No tree project found for random number ${randomNumber}. Available ranges: ${JSON.stringify(
        treeProjects.map(p => ({ id: p.projectId, range: [p.probabilityLowerBound, p.probabilityUpperBound] })),
      )}`,
    );
  }

  return project.projectId;
};
